import { Col, Row } from "react-grid-system"
import { ReportData } from ".."
import { HorizontalSpacer } from "../../components/atoms/spacers"
import { isEvenNumber, mbGbDisplay } from "../../utils/helpers"
import { reportTerminals, terminalCombinedDataUsage } from "../reports-helpers"
import ReportPageTemplate from "./ReportPageTemplate"
import styled from "styled-components"
import { ReportText } from "../components/ReportText"

export const TERMINALS_PER_PAGE = 10

const BarContentContainer = styled.div<{ greybg?: boolean }>`
  background-color: ${(props) => (props.greybg ? props.theme.colors.greyLighter : props.theme.colors.white)};
  padding: ${(props) => props.theme.spacings.small};
`

const SortingCol = styled(Col)`
  display: flex;
  justify-content: center;
`

const ReportTerminalsList = ({
  data,
  terminals,
}: {
  data: ReportData
  terminals: ReturnType<typeof reportTerminals>
}) => {
  const sharedPlan = (data.type === "dataplan" && data.sharedPlan) || data.type === "terminal"
  const colWidth = sharedPlan ? 2 : 3
  return (
    <div>
      <Row justify="center">
        <HorizontalSpacer spacing={1}></HorizontalSpacer>
        <SortingCol md={colWidth}>
          <ReportText>Serial Number</ReportText>
        </SortingCol>
        <SortingCol md={colWidth}>
          <ReportText>Modem Sn.</ReportText>
        </SortingCol>
        <SortingCol md={colWidth}>
          <ReportText>Nickname</ReportText>
        </SortingCol>
        <SortingCol md={colWidth}>
          <ReportText>Data Usage</ReportText>
        </SortingCol>
        {sharedPlan && (
          <SortingCol md={colWidth}>
            <ReportText>Dataplan</ReportText>
          </SortingCol>
        )}
        <HorizontalSpacer spacing={1}></HorizontalSpacer>
      </Row>
      {terminals.map(({ terminal, plan }, index) => {
        const columnData = [
          terminal.serialNumber,
          terminal.modemSn,
          terminal.nickname,
          mbGbDisplay(terminalCombinedDataUsage(terminal, plan?.id!) ?? plan?.totalDataUsage ?? 0),
        ]

        if (sharedPlan) {
          columnData.push(plan?.name ?? "None")
        }

        return (
          <BarContentContainer key={terminal.serialNumber} greybg={isEvenNumber(index)}>
            <Row justify="center" align="center">
              {columnData.map((value) => (
                <SortingCol key={value} md={colWidth}>
                  <ReportText>{value}</ReportText>
                </SortingCol>
              ))}
            </Row>
          </BarContentContainer>
        )
      })}
    </div>
  )
}

const ReportTerminalsPage = ({
  data,
  terminals,
  total,
  index,
}: {
  data: ReportData
  terminals: ReturnType<typeof reportTerminals>
  total: number
  index: number
}) => {
  const first = index * TERMINALS_PER_PAGE + 1
  const last = (index + 1) * TERMINALS_PER_PAGE
  const isLastPage = last >= total

  return (
    <ReportPageTemplate subtitle={`Terminals ${first} - ${isLastPage ? total : last} (${total})`}>
      <ReportTerminalsList data={data} terminals={terminals} />
    </ReportPageTemplate>
  )
}

export default ReportTerminalsPage
